export default __webpack_public_path__ + "static/media/kp.ee3e37b5.svg";